<app-base-section>
<div class="presentation">
  <h2 class="title title--h1alt">{{ file.title }}</h2>
  <div class="cms-content" *ngIf="file.introduction" [innerHTML]="file.introduction"></div>
  <div class="btn-wrapper" *ngIf="file.url">
    <a [routerLink]="file.url" class="btn btn--sm">{{'Common.Actions.read_more'|translate}}</a>
  </div>
  <ul class="list--links" *ngIf="file.children && file.children.length">
    <li *ngFor="let child of file.children">
      <a [routerLink]="child.url" class="links__link">
        {{ child.title }}
      </a>
    </li>
  </ul>
</div>
</app-base-section>
